@if (!accepted()) {
  <div class="cookies">
    <div class="alert-warning flex flex-col gap-2">
      <div>
        <ng-container ngInclude />
      </div>

      <div>
        <a [routerLink]="['/cookie-policy']">
          {{ "COOKIE_POLICY.SHOW_BUTTON" | translate }}
        </a>
      </div>

      <div class="flex justify-end">
        <button color="accent" mat-flat-button type="button" (click)="acceptCookiePolicy()">
          {{ "ACCEPT" | translate }}
        </button>
      </div>
    </div>
  </div>
}
